var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "div",
        { staticClass: "details-view", staticStyle: { overflow: "auto" } },
        [
          _c(
            "div",
            {
              staticClass: "main-content",
              staticStyle: { width: "fit-content" }
            },
            [
              _c("div", { staticStyle: { display: "flex" } }, [
                _c(
                  "div",
                  { staticClass: "section form-column" },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          "label-width": "140px",
                          "label-position": "right"
                        }
                      },
                      [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BasicInfo")))
                        ]),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "CargoMsg.Cargo_DirectOrTransshipment"
                              ),
                              required: ""
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "directTransit",
                                "tag-value": "code",
                                filterable: "",
                                clearable: false,
                                "default-value": _vm.filter.directTransit,
                                "static-options":
                                  _vm.SystemConstants.DIRECT_TRANSITS
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.filter.directTransit = p.value
                                  _vm.filter.transferPortCode = ""
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Airline"),
                              required: ""
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                "select-type": _vm.TYPE_NAMES.basic_data_Region,
                                filterable: "",
                                "default-value": _vm.filter.commerceCode
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.filter.commerceCode = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm.type ===
                          _vm.SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code ||
                        _vm.type ===
                          _vm.SystemConstants.PRICE_INQUIRY_TYPE_SEA_LCL.code
                          ? _c(
                              "el-form-item",
                              {
                                attrs: { label: _vm.$t("CargoMsg.Cargo_POL") }
                              },
                              [
                                _c("cargo-advance-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    "select-type":
                                      _vm.TYPE_NAMES.basic_data_Seaport,
                                    filterable: "",
                                    "default-value": _vm.filter.pol
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      return (_vm.filter.pol = p.value)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.type ===
                        _vm.SystemConstants.PRICE_INQUIRY_TYPE_AIR.code
                          ? _c(
                              "el-form-item",
                              { attrs: { label: _vm.$t("Invoice.Origin") } },
                              [
                                _c("cargo-advance-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    "select-type":
                                      _vm.TYPE_NAMES.basic_data_Airport,
                                    filterable: "",
                                    "default-value": _vm.filter.pol
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      return (_vm.filter.pol = p.value)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.type ===
                          _vm.SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code ||
                        _vm.type ===
                          _vm.SystemConstants.PRICE_INQUIRY_TYPE_SEA_LCL.code
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "CargoMsg.Cargo_PortOfDischarge"
                                  )
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    "select-type":
                                      _vm.TYPE_NAMES.basic_data_Seaport,
                                    filterable: "",
                                    "default-value": _vm.filter.pod
                                  },
                                  on: { parentCallBack: _vm.podChange }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.type ===
                        _vm.SystemConstants.PRICE_INQUIRY_TYPE_AIR.code
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_Destination")
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    "select-type":
                                      _vm.TYPE_NAMES.basic_data_Airport,
                                    filterable: "",
                                    "default-value": _vm.filter.pod
                                  },
                                  on: { parentCallBack: _vm.podChange }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.filter.directTransit ===
                        _vm.SystemConstants.DIRECT_TRANSIT_TRANSIT.code
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaExport.TransitPort"),
                                  required: ""
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    "select-type":
                                      _vm.TYPE_NAMES.basic_data_Seaport,
                                    filterable: "",
                                    "default-value": _vm.filter.transferPortCode
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      return (_vm.filter.transferPortCode =
                                        p.value)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.type ===
                          _vm.SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code ||
                        _vm.type ===
                          _vm.SystemConstants.PRICE_INQUIRY_TYPE_SEA_LCL.code
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaExport.ShippingCompany")
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    no: "carrierId",
                                    filterable: "",
                                    "select-type":
                                      _vm.TYPE_NAMES.basic_data_Company,
                                    "method-params": {
                                      seaCmp: true,
                                      companyLob: "seaExport",
                                      active: true
                                    },
                                    "default-value": _vm.filter.carrierId || "",
                                    placeholder: " "
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      return (_vm.filter.carrierId = p.value)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.type ===
                        _vm.SystemConstants.PRICE_INQUIRY_TYPE_AIR.code
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_AirlineCompany")
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    no: "carrierId",
                                    filterable: "",
                                    "select-type":
                                      _vm.TYPE_NAMES.basic_data_Company,
                                    "method-params": {
                                      airCmp: true,
                                      companyLob: "airExport",
                                      active: true
                                    },
                                    "default-value": _vm.filter.carrierId || "",
                                    placeholder: " "
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      return (_vm.filter.carrierId = p.value)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("CargoMsg.Cargo_Terms") } },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "serviceTerm",
                                filterable: "",
                                "select-type":
                                  _vm.TYPE_NAMES.basic_data_IncoTerm,
                                "callback-method-type": "value",
                                "default-value": _vm.filter.serviceTerm,
                                "callback-params": { key: "incoTerm" }
                              },
                              on: {
                                parentCallBack: function(p) {
                                  return (_vm.filter.serviceTerm = p.value)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "section form-column" },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          "label-width": "140px",
                          "label-position": "right"
                        }
                      },
                      [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CargoInfo")))
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("SeaExport.CargoType") } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.type,
                                  callback: function($$v) {
                                    _vm.type = $$v
                                  },
                                  expression: "type"
                                }
                              },
                              [
                                _c(
                                  "el-radio",
                                  {
                                    staticStyle: { "margin-right": "5px" },
                                    attrs: {
                                      label:
                                        _vm.SystemConstants
                                          .PRICE_INQUIRY_TYPE_SEA_FCL.code
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_FCL")))]
                                ),
                                _c(
                                  "el-radio",
                                  {
                                    staticStyle: { "margin-right": "5px" },
                                    attrs: {
                                      label:
                                        _vm.SystemConstants
                                          .PRICE_INQUIRY_TYPE_SEA_LCL.code
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Pricing.LCL")))]
                                ),
                                _c(
                                  "el-radio",
                                  {
                                    staticStyle: { "margin-right": "5px" },
                                    attrs: {
                                      label:
                                        _vm.SystemConstants
                                          .PRICE_INQUIRY_TYPE_AIR.code
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Air")))]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm.type ===
                        _vm.SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code
                          ? _c("span", { staticClass: "title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_CartonQuantity")
                                ) + " "
                              ),
                              _c("i", {
                                staticClass: "el-icon-circle-plus",
                                staticStyle: {
                                  color: "#42b983",
                                  cursor: "pointer",
                                  right: "35px",
                                  top: "-4px",
                                  "font-size": "18px"
                                },
                                on: { click: _vm.addSeaEq }
                              })
                            ])
                          : _vm._e(),
                        _vm._l(_vm.filter.seaEqList, function(seaEq, index) {
                          return _vm.type ===
                            _vm.SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code
                            ? _c("div", { key: index }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                      "justify-content": "flex-start"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_ContainerSize"
                                          ),
                                          required: ""
                                        }
                                      },
                                      [
                                        _c("cargo-advance-select", {
                                          staticStyle: { width: "200px" },
                                          attrs: {
                                            no: "type",
                                            "tag-value": "code",
                                            filterable: "",
                                            clearable: false,
                                            "default-value": seaEq.type,
                                            "static-options":
                                              _vm.SystemConstants.SEA_EQ_TYPES
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              seaEq.type = p.value
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_AmountNumber"
                                          ),
                                          required: ""
                                        }
                                      },
                                      [
                                        _c("el-input-number", {
                                          staticStyle: { width: "140px" },
                                          attrs: {
                                            no: "quantity",
                                            clearable: false,
                                            "controls-position": "right",
                                            precision: 0,
                                            min: 1
                                          },
                                          model: {
                                            value: seaEq.quantity,
                                            callback: function($$v) {
                                              _vm.$set(seaEq, "quantity", $$v)
                                            },
                                            expression: "seaEq.quantity"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("i", {
                                      staticClass: "el-icon-remove",
                                      staticStyle: {
                                        color: "#f56c6c",
                                        cursor: "pointer",
                                        right: "35px",
                                        top: "5px",
                                        "font-size": "18px"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteSeaEq(index)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            : _vm._e()
                        })
                      ],
                      2
                    ),
                    _vm.filter.prePortEnable
                      ? _c(
                          "el-form",
                          {
                            staticClass: "form-item-200",
                            attrs: { inline: true, "label-position": "right" }
                          },
                          [
                            _c("span", { staticClass: "title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_PackingDoorPoint")
                                )
                              )
                            ]),
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("cargo-area", {
                                  staticStyle: {
                                    display: "inline-block",
                                    "margin-left": "115px"
                                  },
                                  attrs: {
                                    no: "city",
                                    country: "CN",
                                    province: _vm.filter.province,
                                    city: _vm.filter.city,
                                    district: _vm.filter.districts,
                                    town: _vm.filter.townUuid,
                                    "show-town": true,
                                    "select-width": 150
                                  },
                                  on: {
                                    "update:province": function($event) {
                                      return _vm.$set(
                                        _vm.filter,
                                        "province",
                                        $event
                                      )
                                    },
                                    "update:city": function($event) {
                                      return _vm.$set(
                                        _vm.filter,
                                        "city",
                                        $event
                                      )
                                    },
                                    "update:district": function($event) {
                                      return _vm.$set(
                                        _vm.filter,
                                        "districts",
                                        $event
                                      )
                                    },
                                    "update:town": function($event) {
                                      return _vm.$set(
                                        _vm.filter,
                                        "townUuid",
                                        $event
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.filter.lastMileEnable
                      ? _c(
                          "el-form",
                          {
                            attrs: {
                              "label-width": "140px",
                              "label-position": "right"
                            }
                          },
                          [
                            _c("span", { staticClass: "title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "CargoMsg.Cargo_LastMileDeliveryAddress"
                                  )
                                )
                              )
                            ]),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "CargoMsg.Cargo_DeliveryAddressType"
                                  ),
                                  required: ""
                                }
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    on: {
                                      change: _vm.deliveryAddressTypeChange
                                    },
                                    model: {
                                      value: _vm.filter.deliveryAddressType,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filter,
                                          "deliveryAddressType",
                                          $$v
                                        )
                                      },
                                      expression: "filter.deliveryAddressType"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      {
                                        staticStyle: { "margin-right": "5px" },
                                        attrs: {
                                          label:
                                            _vm.SystemConstants
                                              .DELIVERY_ADDRESS_TYPE_THIRD_PARTY
                                              .code
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_ThirdPartyAddress"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-radio",
                                      {
                                        staticStyle: { "margin-right": "5px" },
                                        attrs: {
                                          label:
                                            _vm.SystemConstants
                                              .DELIVERY_ADDRESS_TYPE_AMAZON_WAREHOUSE
                                              .code
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_AmazonWarehouse"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-radio",
                                      {
                                        staticStyle: { "margin-right": "5px" },
                                        attrs: {
                                          label:
                                            _vm.SystemConstants
                                              .DELIVERY_ADDRESS_TYPE_ECANG.code
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("CargoMsg.Cargo_YiCang")
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-radio",
                                      {
                                        staticStyle: { "margin-right": "5px" },
                                        attrs: {
                                          label:
                                            _vm.SystemConstants
                                              .DELIVERY_ADDRESS_TYPE_WALMART_WAREHOUSE
                                              .code
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_WalmartWarehouse"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm.filter.deliveryAddressType ===
                            _vm.SystemConstants
                              .DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SeaExport.ZIP"),
                                      required: ""
                                    }
                                  },
                                  [
                                    _c("cargo-post-code-select", {
                                      attrs: {
                                        "default-value": _vm.filter.postalCode
                                      },
                                      on: { change: _vm.postCodeChange }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.filter.deliveryAddressType ===
                            _vm.SystemConstants
                              .DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: _vm.$t("SeaExport.Addr") }
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: _vm.filter.address,
                                        callback: function($$v) {
                                          _vm.$set(_vm.filter, "address", $$v)
                                        },
                                        expression: "filter.address"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.filter.deliveryAddressType ===
                              _vm.SystemConstants
                                .DELIVERY_ADDRESS_TYPE_AMAZON_WAREHOUSE.code ||
                            _vm.filter.deliveryAddressType ===
                              _vm.SystemConstants.DELIVERY_ADDRESS_TYPE_ECANG
                                .code ||
                            _vm.filter.deliveryAddressType ===
                              _vm.SystemConstants
                                .DELIVERY_ADDRESS_TYPE_WALMART_WAREHOUSE.code
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_WarehouseCode2"
                                      ),
                                      required: ""
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        no: "overseaWarehouseCode",
                                        "select-type":
                                          _vm.TYPE_NAMES
                                            .basic_data_OverseaWarehouse,
                                        filterable: "",
                                        "method-params": { ifFba: true },
                                        clearable: false,
                                        "tag-name": "warehouseCode",
                                        "tag-value": "warehouseCode",
                                        "default-value":
                                          _vm.filter.warehouseCode
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.filter.warehouseCode = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]
          )
        ]
      ),
      _c("cargo-ai-recognition-dialog", {
        attrs: {
          visible: _vm.aiRecognitionDialog.visible,
          multimodal: _vm.aiRecognitionDialog.multimodal,
          "prompt-key": _vm.aiRecognitionDialog.promptKey,
          "call-back": _vm.aiRecognitionDialog.callBack,
          title: _vm.$t("CargoMsg.CargoMsg_AIAddressRecognition"),
          placeholder: _vm.aiRecognitionDialog.placeholder
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.aiRecognitionDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }